<template>
  <div class="file-item" :class="{ 'selected': selected }"  @contextmenu.stop="clickMore(info)">
    <!-- 公有标签 -->
    <div v-if="info.fileInfo.publicFlag === 1" class="public-tag">公共</div>
    <!-- 批量审批勾选框 -->
    <el-checkbox v-if="batchApprovalMode && info.fileInfo.status === 0" v-model="isChecked" @change="handleCheckChange"
      class="batch-checkbox" @click.native.stop></el-checkbox>
    <!-- 文件对比勾选框 -->
    <el-checkbox v-if="compareMode && info.fileInfo.fileType =='docx'" v-model="isCompareChecked" @change="handleCompareCheckChange"
      class="batch-checkbox" @click.native.stop></el-checkbox>

    <div>
      <div class="imgBox" :style="getBackStyle()" :id="info.fileInfo.fileId"></div>
    </div>
    <div class="text-content">
      <div class="title" :title="info.fileInfo.fileName + ' - ' + info.fileInfo.version">
        <el-tag size="mini" v-if="info.fileInfo.status !== null && statusMap[info.fileInfo.status]"
          style="font-size: 10px;" :type="statusMap[info.fileInfo.status][0]">
          {{ statusMap[info.fileInfo.status][1] }}
        </el-tag>
        <span class="file-name">{{ info.fileInfo.fileName }}</span>
        <span class="version-tag">{{ info.fileInfo.version }}</span>
      </div>
      <div class="title time" :title="info.fileInfo.createDate">{{ info.fileInfo.createDate }}</div>
      <!-- 搜索结果显示位置提示 -->
      <!-- <div v-if="info.fileInfo.isSearchResult" class="location-hint">
        <i class="el-icon-folder-opened"></i>
        <span>点击查看文件位置</span>
      </div> -->
    </div>
    <div class="more" title="更多" v-has="'addFileButton'">
      <i class="el-icon-more" @click.stop="clickMore(info)"></i>
      <fileTab ref="rightTab" @ok="refresh" @moveOk="moveOk" @enterBatchApprovalMode="enterBatchApprovalMode" @enterCompareMode="enterCompareMode">
      </fileTab>
    </div>
  </div>
</template>

<script>
export default {
  name: "fileBox",
  components: {
    'fileTab': () => import('@/components/file/fileTab.vue'),
  },
  props: {
    info: Object,
    selected: {
      type: Boolean,
      default: false
    },
    batchApprovalMode: {
      type: Boolean,
      default: false
    },
    compareMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      backgroundStyle: {
        backgroundImage: `url(${require('@/assets/file/qt.png')})`,
        backgroundSize: 'cover', // 适应容器大小
        backgroundPosition: 'center' // 居中对齐
      },
      isChecked: false,
      isCompareChecked: false
    }
  },
  mounted() {
    console.log('fileBox mounted, compareMode:', this.compareMode);
  },
  watch: {
    batchApprovalMode(newVal) {
      if (!newVal) {
        this.isChecked = false;
      }
    },
    compareMode(newVal) {
      console.log('fileBox compareMode changed:', newVal);
      if (!newVal) {
        this.isCompareChecked = false;
      }
    },
    compareFiles: {
      handler(newVal) {
        // 当父组件的 compareFiles 变化时，检查当前文件是否应该被选中
        if (this.compareMode && newVal) {
          const isSelected = newVal.some(f => f.fileId === this.info.fileInfo.fileId);
          if (this.isCompareChecked !== isSelected) {
            this.isCompareChecked = isSelected;
          }
        }
      },
      deep: true
    }
  },
  computed: {
    statusMap() {
      return {

        0: ['warning', '草稿'],
        1: ['', '待审核'],
        2: ['success', '已生效'],
        '-1': ['danger', '已废止'],
        '-2': ['danger', '审核驳回']
      }
    },
  },

  methods: {
    handleCheckChange(checked) {
      console.log('fileBox handleCheckChange:', checked, this.info.fileInfo);
      this.$emit('checkChange', {
        checked,
        fileInfo: this.info.fileInfo
      });
    },

    handleCompareCheckChange(checked) {
      console.log('fileBox handleCompareCheckChange:', checked, this.info.fileInfo);
      
      // 如果是选中操作，先检查是否已经选了2个文件
      if (checked) {
        // 通过事件通知父组件，让父组件判断是否允许选中
        this.$emit('compareCheckChange', {
          checked,
          fileInfo: this.info.fileInfo
        });
      } else {
        // 取消选中直接通知
        this.$emit('compareCheckChange', {
          checked,
          fileInfo: this.info.fileInfo
        });
      }
    },

    enterBatchApprovalMode() {
      console.log('fileBox enterBatchApprovalMode triggered');
      this.$emit('enterBatchApprovalMode');
    },

    enterCompareMode() {
      console.log('fileBox enterCompareMode triggered');
      this.$emit('enterCompareMode');
    },

    /**
         * 移动回调事件
         * @param node：选择的文件夹
         * @param path：节点路径
         */
    moveOk({ node, path }) {
      //删除第一个去掉首页
      // this.breadcrumbList = path.filter((_, index) => index !== 0);
      // this.pid = node.folderId;
      this.refresh();
    },
    refresh() {
      this.$emit("ok");
    },
    clickMore(info) {
       event.preventDefault();
      this.$refs.rightTab.openDia(info);

    },
    getBackStyle() {
      if (this.$config.supportFile.imgType.indexOf(this.info.fileInfo.fileType) !== -1) {
        this.backgroundStyle.backgroundImage = `url(${this.$util.getOpenFileUrl(this.info.fileInfo.fileId)})`;
      }
      //判断是否能找到对应图片
      let icon = this.$config.supportFile.fileToIconPngMap[this.info.fileInfo.fileType]
      if (icon != null && icon !== "") {
        this.backgroundStyle.backgroundImage = `url(${require('@/assets/file/' + icon)})`
      }
      return this.backgroundStyle;
    }
  }
}
</script>


<style scoped lang="scss">
.file-item {
  width: 100%;
  /* 改为100%，跟随父容器宽度 */
  cursor: pointer;
  display: flex;
  align-items: center;
  position: relative;
  padding: 10px 4px 10px 12px;

  .batch-checkbox {
    position: absolute;
    top: 10px;
    left: 10px;
    z-index: 100;
  }

  .public-tag {
    position: absolute;
    top: 15px;
    left: 12px;
    background: linear-gradient(135deg, #ffd89b 0%, #f9a825 100%);
    color: #fff;
    font-size: 7px;
    padding: 1px 1px;
    border-radius: 0 0 8px 0;
    font-weight: 500;
    box-shadow: 0 2px 4px rgba(249, 168, 37, 0.3);
    z-index: 10;
    line-height: 1.4;
  }

  .text-content {
    flex: 1;
    min-width: 0;
    /* 关键：允许flex子元素收缩到内容宽度以下 */
    margin: 0 0 0 10px;
  }

  .more {
    flex-shrink: 0;
    width: 24px;
    height: 24px;
    display: inline-flex;
    align-items: center;
    justify-content: center;

    opacity: 0;
    visibility: hidden;
    transition: opacity 0.15s ease;
  }

  .title {
    z-index: 900;
    width: 100%;
    color: #363b4c;
    font-size: 14px;
    display: flex;
    align-items: center;
    gap: 4px;

    .file-name {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      flex: 1;
      min-width: 0;
    }

    .version-tag {
      flex-shrink: 0;
      color: #409eff;
      font-weight: 500;
      white-space: nowrap;
    }
  }

  .time {
    color: #6f7588;
    font-size: 12px;
  }

  .imgBox {
    flex-shrink: 0;
    /* 防止图标被压缩 */
    width: 25px;
    height: 25px;

    .fileType {
      top: 0;
      left: 0;
      font-size: 18px;
    }
  }
}

.file-item:hover {
  background-color: #ddeaff;
  border-radius: 4px;

  .more {
    opacity: 1;
    visibility: visible;
  }
}

.file-item.selected {
  background-color: #ddeaff;
  border-radius: 4px;
}

.location-hint {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #409eff;
  font-size: 12px;
  margin-top: 4px;

  i {
    font-size: 14px;
  }

  span {
    font-style: italic;
  }
}
</style>